<div class="unlock-casino-modal">
  <div
    #bgContainer
    class="scene-wrapper"
    theming
    themingGroup="progressline"
    [themingAsset]="'background-' + data().casino.order">
    <div
      #confettiBack
      class="fixed"
      theming
      themingGroup="progressline"
      [themingAsset]="'unlock-casino-confetti-back'"></div>
    <div
      #confettiFront
      class="fixed confetti-front"
      theming
      themingGroup="progressline"
      [themingAsset]="'unlock-casino-confetti-front'"></div>
    <div
      #juliet
      class="fixed juliet"
      theming
      themingGroup="progressline"
      [themingAsset]="julietAsset()">
      <div
        #bubbleContainer
        class="bubble-container"
        [style.visibility]="isBubbleHidden() ? 'hidden' : 'visible'">
        <svg
          class="bubble-svg"
          [attr.width]="layout().totalWidth"
          [attr.height]="layout().totalHeight">
          @if (layout().totalWidth > 0 && layout().totalHeight > 0) {
            <defs>
              <filter
                id="bubbleBodyGlow"
                x="-50%"
                y="-50%"
                width="200%"
                height="200%"
                filterUnits="objectBoundingBox">
                <feGaussianBlur
                  in="SourceAlpha"
                  [attr.stdDeviation]="bubbleConfig.glowSpread"
                  result="outerBlur" />
                <feFlood
                  [attr.flood-color]="bubbleConfig.glowColor"
                  [attr.flood-opacity]="bubbleConfig.glowOpacity"
                  result="outerFill" />
                <feComposite
                  in="outerFill"
                  in2="outerBlur"
                  operator="in"
                  result="coloredOuterGlow" />
                <feGaussianBlur
                  in="SourceAlpha"
                  [attr.stdDeviation]="bubbleConfig.glowSpread * 0.4"
                  result="tightOuterBlur" />
                <feFlood
                  [attr.flood-color]="bubbleConfig.glowColor"
                  [attr.flood-opacity]="bubbleConfig.glowOpacity * 0.5"
                  result="tightOuterFill" />
                <feComposite
                  in="tightOuterFill"
                  in2="tightOuterBlur"
                  operator="in"
                  result="tighterOuterGlow" />
                <feFlood
                  flood-color="white"
                  flood-opacity="1"
                  result="whiteFlood" />
                <feComposite
                  in="whiteFlood"
                  in2="SourceAlpha"
                  operator="out"
                  result="invertedAlpha" />
                <feGaussianBlur
                  in="invertedAlpha"
                  [attr.stdDeviation]="bubbleConfig.innerGlowSpread"
                  result="blurredInvert" />
                <feComposite
                  in="blurredInvert"
                  in2="SourceAlpha"
                  operator="in"
                  result="innerEdge" />
                <feFlood
                  [attr.flood-color]="bubbleConfig.innerGlowColor"
                  [attr.flood-opacity]="bubbleConfig.innerGlowOpacity"
                  result="innerGlowFill" />
                <feComposite
                  in="innerGlowFill"
                  in2="innerEdge"
                  operator="in"
                  result="coloredInnerGlow" />
                <feGaussianBlur
                  in="invertedAlpha"
                  [attr.stdDeviation]="bubbleConfig.innerGlowSpread * 0.4"
                  result="tightInnerBlur" />
                <feComposite
                  in="tightInnerBlur"
                  in2="SourceAlpha"
                  operator="in"
                  result="tightInnerEdge" />
                <feFlood
                  [attr.flood-color]="bubbleConfig.innerGlowColor"
                  [attr.flood-opacity]="bubbleConfig.innerGlowOpacity * 0.5"
                  result="tightInnerFill" />
                <feComposite
                  in="tightInnerFill"
                  in2="tightInnerEdge"
                  operator="in"
                  result="tighterInnerGlow" />
                <feMerge>
                  <feMergeNode in="coloredOuterGlow" />
                  <feMergeNode in="tighterOuterGlow" />
                  <feMergeNode in="SourceGraphic" />
                  <feMergeNode in="coloredInnerGlow" />
                  <feMergeNode in="tighterInnerGlow" />
                </feMerge>
              </filter>
              <filter
                id="bubbleStrokeGlow"
                x="-50%"
                y="-50%"
                width="200%"
                height="200%"
                filterUnits="objectBoundingBox">
                <feGaussianBlur
                  in="SourceGraphic"
                  [attr.stdDeviation]="bubbleConfig.strokeGlowSpread"
                  result="outerStrokeMelt" />
                <feGaussianBlur
                  in="SourceGraphic"
                  [attr.stdDeviation]="bubbleConfig.strokeGlowSpread * 0.5"
                  result="midStrokeMelt" />
                <feGaussianBlur
                  in="SourceGraphic"
                  [attr.stdDeviation]="bubbleConfig.strokeGlowSpread * 0.25"
                  result="innerStrokeMelt" />
                <feComponentTransfer
                  in="outerStrokeMelt"
                  result="fadedOuterMelt">
                  <feFuncA
                    type="linear"
                    [attr.slope]="bubbleConfig.strokeGlowOpacity" />
                </feComponentTransfer>
                <feComponentTransfer
                  in="midStrokeMelt"
                  result="fadedMidMelt">
                  <feFuncA
                    type="linear"
                    [attr.slope]="bubbleConfig.strokeGlowOpacity * 0.7" />
                </feComponentTransfer>

                <feMerge>
                  <feMergeNode in="fadedOuterMelt" />
                  <feMergeNode in="fadedMidMelt" />
                  <feMergeNode in="innerStrokeMelt" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>
            <path
              [attr.d]="layout().path"
              [attr.fill]="bubbleConfig.bgColor"
              stroke="none"
              filter="url(#bubbleBodyGlow)" />
            <path
              [attr.d]="layout().path"
              fill="none"
              [attr.stroke]="bubbleConfig.borderColor"
              [attr.stroke-width]="bubbleConfig.borderWidth"
              vector-effect="non-scaling-stroke"
              stroke-linejoin="round"
              stroke-linecap="round"
              filter="url(#bubbleStrokeGlow)" />
          }
        </svg>
        <div
          #textWrapper
          class="bubble-text-content"
          [style.paddingLeft.px]="bubblePadding.left"
          [style.paddingRight.px]="bubblePadding.right"
          [style.paddingTop.px]="bubblePadding.vertical"
          [style.paddingBottom.px]="bubblePadding.vertical">
          <slotcom-p [text]="'home.progress-line.casino-discovered' | translate"></slotcom-p>
        </div>
      </div>
    </div>
    <div
      #casinoLogo
      class="casino-logo"
      theming
      themingGroup="progressline"
      [themingAsset]="'logo-' + data().casino.order"></div>
    <div
      #casinoInfo
      class="casino-info-wrapper">
      <div class="casino-container">
        <div
          class="casino-pill"
          theming
          themingGroup="progressline"
          [themingAsset]="'casino-order-' + casinoTier() + '-background'">
          <span>{{ 'home.progress-line.milestone.casino' | translate: { x: data().casino.order } }}</span>
        </div>
        <div
          class="casino-title-container"
          theming
          themingGroup="progressline"
          [themingAsset]="'casino-title-' + data().casino.order"></div>
      </div>
      <div class="rewards-container">
        <slotcom-p
          [bold]="true"
          [shadow]="true"
          [shadowBorder]="true"
          [text]="'home.progress-line.new-casino-rewards' | translate"></slotcom-p>
        <div class="rewards-icons">
          @for (prize of filteredPrizesUI(); track $index) {
            <div
              #rewardItem
              class="prize-container"
              data-testid="slotcom-prize-container">
              <div
                theming
                themingGroup="progressline"
                [themingAsset]="'reward-' + prize.icon"
                class="reward-img"></div>
              @if (prize.type === 'currency' || prize.type === 'recurring') {
                <slotcom-display class="display-prize">
                  <div
                    displayIcon
                    displayIconPos="left"
                    [ngClass]="prize.icon === 'hard' ? 'c-display--gem' : 'c-display--coin'"></div>

                  <span>
                    {{
                      prize.type === 'recurring'
                        ? '+' + (prize.text | number: '1.0-0' : ('common.culture' | translate))
                        : (prize.text | notRoundingBeautifyNumber: ('common.culture' | translate))
                    }}
                  </span>
                </slotcom-display>
              }
              @if (prize.type === 'game') {
                <div class="tier-display">
                  <slotcom-display class="display-slots">
                    <span> x{{ data().games.length | translate }} </span>
                  </slotcom-display>
                  <div
                    class="tier-icon"
                    displayIcon
                    displayIconPos="right"
                    theming
                    themingGroup="none"
                    [themingAsset]="'pl-tier-' + data().casino.order"></div>
                </div>
              }
            </div>
          }
        </div>
      </div>
      <div class="button-container">
        <div #confirmButton>
          <slotcom-button
            class="c-button--pink"
            data-testid="slotcom-unlock-casino-button"
            (safeClick)="handleClick()"
            audioType="reward">
            {{ 'home.buttons.great' | translate | uppercase }}
          </slotcom-button>
        </div>
      </div>
    </div>
    <div
      class="slots-container"
      #slotsContainer>
      <div
        #slotsTitle
        class="slots-title">
        <slotcom-p
          [bold]="true"
          [shadow]="true"
          [shadowBorder]="true"
          [fontSize]="3"
          size="large"
          text="{{ 'home.progress-line.new-features' | translate: { x: data().games.length } | uppercase }}">
        </slotcom-p>
      </div>
      <div class="slots-list">
        @for (game of data().games; track $index) {
          @if ($index < 10) {
            <div
              #slotsIcons
              class="slot-item">
              <img [src]="game.imgSrc" />
            </div>
          }
        }
      </div>
      <div
        #slotsDisplay
        class="slots-display">
        <slotcom-display [classes]="['c-display--wallet']">
          <div
            class="icon"
            displayIcon
            displayIconPos="right"
            theming
            themingGroup="none"
            [themingAsset]="'pl-tier-' + data().casino.order"></div>
          {{ 'home.lobby.modals.level-up.title' | translate | uppercase }}
        </slotcom-display>
      </div>
      <div #finalButton>
        <slotcom-button
          class="c-button--pink"
          data-testid="slotcom-unlock-casino-final-button"
          (safeClick)="handleClick()"
          audioType="reward">
          {{ 'home.buttons.collect' | translate | uppercase }}
        </slotcom-button>
      </div>
    </div>
  </div>
</div>
